// Auto-generated: imports for all component scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/components/button/script.js';
import '../../flex/components/info_boxes/script.js';
import '../../flex/components/select/script.js';
